import { useCallback, useEffect, useRef, useState } from 'react';
import { getAccountWorkspace } from '@/services/account.service.js';

export default function useAccount(idOrSlug) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const aborted = useRef(false);

  const refresh = useCallback(async () => {
    if (!idOrSlug) return;
    setLoading(true);
    setError(null);
    try {
      const d = await getAccountWorkspace(idOrSlug);
      if (!aborted.current) setData(d);
    } catch (err) {
      if (!aborted.current) setError(err);
    } finally {
      if (!aborted.current) setLoading(false);
    }
  }, [idOrSlug]);

  useEffect(() => {
    aborted.current = false;
    refresh();
    return () => {
      aborted.current = true;
    };
  }, [refresh]);

  return { data, error, loading, refresh };
}
